// extracted by mini-css-extract-plugin
export default {"root":"Loader_root__tYqQb","logo":"Loader_logo__iYg4x","text":"Loader_text__lMyJ4"};